import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { fabric } from 'fabric'
import { CANVAS_SIZE, canvasObjConstantProperties } from '../constants'

const _ = require('lodash')

class DrawingCanvas extends React.Component {
  componentDidMount() {
    if (!this.canvas) {
      this.initializeCanvas()
      if (this.props.canvasObjects) {
        this.loadObjectsToCanvas(this.props.canvasObjects)
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    // When new canvas items arrive or get deleted, we refresh the canvas.
    if (
      nextProps.canvasObjects &&
      _.get(nextProps, 'canvasObjects.length') !== _.get(this.props, 'canvasObjects.length')
    ) {
      this.loadObjectsToCanvas(nextProps.canvasObjects)
      return true
    }
    return false
  }

  initializeCanvas() {
    const canvas = new fabric.Canvas(this.props.drawingSquareId, {
      width: CANVAS_SIZE,
      height: CANVAS_SIZE,
      isDrawingMode: this.props.drawingMode,
    })
    this.canvas = canvas
  }

  rehydrateCanvasObjectProperties = (canvasObjects) =>
    canvasObjects.map((obj) => ({ ...obj, ...canvasObjConstantProperties }))

  loadObjectsToCanvas = (canvasObjects) => {
    this.canvas.loadFromJSON({ objects: this.rehydrateCanvasObjectProperties(canvasObjects) })
  }

  componentWillUnmount() {
    this.canvas.dispose()
  }

  render() {
    const { drawingSquareId, zoom = 1 } = this.props
    return (
      <div style={{ width: CANVAS_SIZE, height: CANVAS_SIZE, zoom }}>
        {/* We refer to the fabric canvas using its id */}
        <canvas id={drawingSquareId} />
      </div>
    )
  }
}

export default compose(
  firebaseConnect((props) => {
    return [
      { path: `canvasSnapshots/${props.drawingSquareId}/canvasSnapshot/objects`, type: 'once' },
      {
        path: `canvasSnapshots/${props.drawingSquareId}/canvasSnapshot/objects`,
        type: 'child_added',
        queryParams: ['limitToLast=1'], // This avoids downloading the initial batch 1 at a time since child_added occurs before the "once" batch request.
      },
      {
        path: `canvasSnapshots/${props.drawingSquareId}/canvasSnapshot/objects`,
        type: 'child_removed',
      },
    ]
  }),
  connect((state, props) => {
    let canvasObjects = _.get(state.firebase.data, `canvasSnapshots.${props.drawingSquareId}.canvasSnapshot.objects`)
    // When an UNDO occurs, we receive an undefined in place of the child, so we filter it out here.
    canvasObjects = canvasObjects ? Object.values(canvasObjects).filter((el) => !!el) : canvasObjects
    return {
      canvasObjects,
    }
  }),
)(DrawingCanvas)



// WEBPACK FOOTER //
// ./src/components/DrawingCanvas.js